import DeleteIcon from "@mui/icons-material/ClearOutlined";
// import EditIcon from "@mui/icons-material/Create";
import ViewIcon from "@mui/icons-material/Visibility";
import { styled } from "@mui/material/styles";
import React from "react";

import GetContent from "./render-form";

const Container = styled("div")(({ theme }) => ({
  marginBottom: "5px",
  padding: "10px",
  minHeight: "50px",
  // backgroundColor: '#eee',
  borderRadius: "4px",
  border: "1px solid #c1c1c1",
  position: "relative",
}));

const Actions = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "8px",
  right: "16px",
  fontSize: "18px",
}));

const ErrorIcon = styled(ViewIcon)(({ theme }) => ({
  color: theme.palette.secondary.main,
  cursor: "pointer",
}));

const DeleteIconStyled = styled(DeleteIcon)(({ theme }) => ({
  color: theme.palette.error.main,
  cursor: "pointer",
}));

export default function StyledField(props) {
  const { item, handleDelete, handleEdit, children } = props;

  return (
    <Container>
      {!children ? <GetContent item={item}></GetContent> : children}

      <Actions>
        <ErrorIcon onClick={(event) => handleEdit(event, item)} />
        <DeleteIconStyled onClick={(event) => handleDelete(event, item)} />
      </Actions>
    </Container>
  );
}
